const OUTBOX_KEY = "nexusbiz_outbox";
const PRODUCTS_CACHE = "nexusbiz_products";

export const getOutbox = () => JSON.parse(localStorage.getItem(OUTBOX_KEY) || "[]");
export const setOutbox = (o) => localStorage.setItem(OUTBOX_KEY, JSON.stringify(o));
export const queueSale = (sale) => setOutbox([...getOutbox(), sale]);
export const cacheProducts = (p) => localStorage.setItem(PRODUCTS_CACHE, JSON.stringify(p));
export const getCachedProducts = () => JSON.parse(localStorage.getItem(PRODUCTS_CACHE) || "[]");
